import { Route, Switch } from "wouter";
import { AuthProvider } from "./lib/auth";
import HomePage from "./pages/HomePage";
import StoresPage from "./pages/StoresPage";
import StoreDetailPage from "./pages/StoreDetailPage";
import ArticlesPage from "./pages/ArticlesPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import NotFoundPage from "./pages/NotFoundPage";

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-stone-50">
        <Switch>
          <Route path="/" component={HomePage} />
          <Route path="/stores" component={StoresPage} />
          <Route path="/stores/:id" component={StoreDetailPage} />
          <Route path="/articles" component={ArticlesPage} />
          <Route path="/articles/:slug" component={ArticleDetailPage} />
          <Route path="/contact" component={ContactPage} />
          <Route path="/admin" component={AdminPage} />
          <Route path="/admin/*" component={AdminPage} />
          <Route component={NotFoundPage} />
        </Switch>
      </div>
    </AuthProvider>
  );
}

export default App;
